import { faCrosshairs } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { withIcon } from '../../../core/components/Icon';
import Tooltip from '../../../core/components/Tooltip.tsx';

const FocusIcon = withIcon(faCrosshairs);

interface FocusButtonProps {
    onClick: () => void;
}

const FocusButton = ({ onClick }: FocusButtonProps) => {
    const { t } = useTranslation('assistance');

    return (
        <Tooltip content={t('itemsView.actions.focus')} side="top">
            <button
                className="w-8 h-8 flex-none flex items-center justify-center rounded hover:bg-surface-weak transition-colors"
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
            >
                <FocusIcon className="text-content-strong" />
            </button>
        </Tooltip>
    );
};

export default FocusButton;
